export default {
      id: "download-no-color-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#download-no-color",
      toString: function () {
        return this.url;
      }
    }